export default "__VITE_ASSET__BM8_51$x__"